import React from 'react';
import {Flex, Text} from "@chakra-ui/layout";
import {Heading, Image} from "@chakra-ui/react";
import Classes from "../../images/home/classes.png";
import Dashboard from "../../images/home/dashboard.png";
import Assignments from "../../images/home/assignments.png";
import Notes from "../../images/home/notes.png";
import LiveClass from "../../images/home/liveclass.png"
import Lesson from "../../images/home/lesson.png"

function About() {
  return (
    <Flex flexDirection={"column"}>
      <Flex flexDirection={"column"} justifyContent={"center"} alignItems={"center"} w={"100%"} my={10}>
        <Heading as={"h4"} fontSize={{base: "lg", md: "2xl", lg: "4xl"}} textAlign={"center"}>
          Learn in a <span className={"colored__text"}>simple, interactive</span> <br/> and <span
          className={"colored__text"}>easier</span> way
        </Heading>
        <Flex flexDirection={"column"} justifyContent={"center"} alignItems={"center"} w={"100%"} mt={10}
              pos={"relative"} px={2}>
          <Image
            title={"dashboard image"}
            src={Dashboard}
            alt={"image of the dashboard page"}
            objectFit="cover"
            objectPosition={"center"}
          />
          <Image
            title={"classes image"}
            src={Classes}
            alt={"image of the classes page"}
            objectFit="cover"
            objectPosition={"center"}
            pos={"absolute"}
            top={"30%"}
          />
        </Flex>
      </Flex>

      <Flex flexDirection={{base: "column", lg: "row"}} mt={28} mb={8} px={7}>
        <Flex flexDirection={"column"} justifyContent={"center"} alignItems={"center"} px={{base: 2, lg: 8}} mt={4}>
          <Heading as={"h4"} fontSize={{base: "lg", md: "xl", lg: "4xl"}}>
            Submit assignments <br/> <span className={"colored__text"}>easily</span> and get graded fast
          </Heading>
          <Text color={"brand.grey1"} mt={7}>
            Easily submit assignments given to you and get graded automatically by your teacher
          </Text>
        </Flex>
        <Flex mt={{base: 4, lg: 0}}>
          <Image
            title={"assignments"}
            src={Assignments}
            alt={"assignments page"}
            objectFit="cover"
            objectPosition={"center"}
          />
        </Flex>
      </Flex>

      <Flex flexDirection={{base: "column", lg: "row"}} my={8} px={7}>
        <Flex mt={{base: 4, lg: 0}}>
          <Image
            title={"assignments"}
            src={Lesson}
            alt={"assignments page"}
            objectFit="cover"
            objectPosition={"center"}
          />
        </Flex>
        <Flex flexDirection={"column"} ml={{base: 0, lg: 6}} justifyContent={"center"} alignItems={"center"} px={{base: 2, lg: 8}} mt={4}>
          <Heading as={"h4"} fontSize={{base: "lg", md: "xl", lg: "4xl"}}>
            <span className={"colored__text"}>Watch</span> Lesson sessions uploaded by teachers
          </Heading>
          <Text color={"brand.grey1"} mt={{base: 2, md: 4, lg: 7}}>
            Teachers can upload videos and sessions
            for students to watch for more understanding
            of a topic or subject
          </Text>
        </Flex>
      </Flex>

      <Flex flexDirection={{base: "column", lg: "row"}} my={8} px={7}>
        <Flex flexDirection={"column"} justifyContent={"center"} alignItems={"center"} px={{base: 2, lg: 8}} mt={4}>
          <Heading as={"h4"} fontSize={{base: "lg", md: "xl", lg: "4xl"}}>
            Get <span className={"colored__text"}>Notes</span> From Teachers <span
            className={"colored__text"}>Easily</span>
          </Heading>
          <Text color={"brand.grey1"} mt={{base: 2, md: 4, lg: 7}}>
            Teachers can upload videos and sessions
            for students to watch for more understanding
            of a topic or subject
          </Text>
        </Flex>
        <Flex mt={{base: 4, lg: 0}}>
          <Image
            title={"assignments"}
            src={Notes}
            alt={"assignments page"}
            objectFit="cover"
            objectPosition={"center"}
          />
        </Flex>
      </Flex>

      <Flex flexDirection={{base: "column", lg: "row"}} my={8} px={7}>
        <Flex mt={{base: 4, lg: 0}}>
          <Image
            title={"assignments"}
            src={LiveClass}
            alt={"assignments page"}
            objectFit="cover"
            objectPosition={"center"}
          />
        </Flex>
        <Flex flexDirection={"column"} ml={{base: 0, lg: 6}} justifyContent={"center"} alignItems={"center"} px={{base: 2, lg: 8}} mt={4}>
          <Heading as={"h4"} fontSize={{base: "lg", md: "xl", lg: "4xl"}}>
            <span className={"colored__text"}>Live Classes</span> right from
            your account
          </Heading>
          <Text color={"brand.grey1"} mt={{base: 2, md: 4, lg: 7}}>
            In-House Live classes right from your account
            organized by teachers
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default About;